import {
  ApiClient,
  CurrentStageAndConfig,
  getCurrentStageAndConfig,
} from '@amzn/rangoli-seller-desktop-async-call-wrapper/src/index';

const { config: currentStage }: CurrentStageAndConfig = getCurrentStageAndConfig();

const authConfig = {
  url: currentStage.smartPosUrl,
};
const marketingPageConfig = {
  url: currentStage.marketingPageUrl,
};
const zendeskchatScriptConfig = {
  url: currentStage.chatScript,
};
const smartbizConfig = {
  url: currentStage.smartbizUrl,
};
const storeFrontShareConfig = {
  url: currentStage.storeFrontUrl,
};

const authApiClient = new ApiClient(authConfig);
const smartbizClient = new ApiClient(smartbizConfig);

export const auth = authApiClient.api(),
  marketingPageUrl = marketingPageConfig.url,
  zendeskchatScript = zendeskchatScriptConfig.url,
  storeFrontShareUrl = storeFrontShareConfig.url,
  smartbiz = smartbizClient.api();
